// eslint-disable-next-line import/no-named-default
import { default as TooltipComponent } from '../legacy/Construction/Popover/PopoverContainer';

export default TooltipComponent;
